<template>
  <div style="height:100%">
    <vue-seamless-scroll
      :data="list"
      class="tableBody"
      :class-option="classOption"
    >
      <ul>
        <li class="content" v-for="(item, index) in list" :key="index">
          <div v-if="item.line" class="line"></div>
          <div class="flex mainDiv" v-else>
            <!-- <div style="width:25%">{{ item.xxmc }}</div>
            <div style="width:24%">{{ item.xmlx }}</div>
            <div style="width:23%">{{ item.tzje }}万元</div>
            <div style="width:28%">
              <el-progress :text-inside="true"
                           :stroke-width="20"
                           :percentage="item.jsjd"></el-progress>
            </div> -->
            <div class="leftDiv">
              <div :ref="item.id" :id="item.id" class="chart"></div>
            </div>
            <div class="rightDiv flex">
              <div class="rightTop">{{ item.xxmc }}</div>
              <div class="rightMid">
                <!-- <jdt total=100 :value='item.jsjd'></jdt> -->
                <div class="jdt flex">
                  <el-progress :percentage="item.jsjd"></el-progress>
                </div>
              </div>
              <div class="rightBot flex">
                <span>项目分类：{{ item.xmlx }}</span
                ><span>投资金额：{{ item.tzje }}万元</span>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </vue-seamless-scroll>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { loadChart } from "../chart/xmData";
import { findDataProjectYNQYXMXX } from "@/api/base";
// import jdt from './jdt'
export default {
  components: {
    // jdt
  },
  computed: {
    classOption() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true // 开启数据实时监控刷新dom
      };
    },
    ...mapGetters(["graphic"])
  },
  data() {
    return {
      list: []
    };
  },
  mounted() {
    // this.list = [
    //   {
    //     edate_: '2020-12-31 00:00:00',
    //     id: 'd11013edb85d41eb80ad4c637620b9aa',
    //     jsjd: '55',
    //     tzje: '300.00',
    //     xmlx: '农业设施',
    //     xxmc: '丝苗米农旅（红色）示范建设项目',
    //     zjtr: '100.00',
    //   },
    // ]
    // let obj = {
    //   line: true,
    // }
    // this.list.push(obj)
    this.chartData();
  },
  methods: {
    chartData() {
      findDataProjectYNQYXMXX({ company_id_: this.graphic.id }).then(res => {
        this.list = res.data;
        let obj = {
          line: true
        };
        this.list.push(obj);
        setTimeout(() => {
          for (let i = 0, len = this.list.length; i < len; i++) {
            this.chart = this.$echarts.init(
              document.getElementById(this.list[i].id)
            );
            loadChart(this.chart, this.list[i].jsjd);
            window.addEventListener("resize", () => {
              this.chart.resize();
            });
          }
        }, 100);
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.tableTitle
  background rgba(0, 66, 82, 0.6)
  color #fff
  padding 10px 5px
  font-size 14px
.tableBody
  height calc(100% - 6px)
  overflow hidden
  font-size 14px
.scroll-content
  position relative
  transition top 0.1s
.content
  padding 10px 5px
  background rgba(10, 37, 80, 0.7)
  box-shadow 0px 0px 15px #0B4378 inset
  border 1px #0B4378 solid
  color #fff
  margin-bottom 10px
.content:last-child
  margin-bottom 0px
.line
  height 1px
  background #66ccff
.leftDiv
  width 0.55rem
  height 100%
  >>>.el-progress-circle
    height 100% !important
    width 100% !important
    svg
      height 100% !important
  >>>.el-progress
    height 100% !important
    width 100% !important
  >>>.el-progress-circle__track
    stroke rgba(0, 122, 255, 0.4)
  >>>.el-progress__text
    color #ffffff
.rightDiv
  width calc(100% - 0.55rem)
  height 100%
  flex-wrap wrap
.rightMid
  width 100%
.chart
  height 100%
  width 100%
.mainDiv
  width calc(100% - 12px)
  height 0.55rem
.rightBot
  justify-content space-between
  width 100%
.jdt
  height 100%
  width 100%
  justify-content center
  >>>.el-progress
    width 100%
  >>>.el-progress-bar__outer
    height 10px !important
  >>>.el-progress-bar
    width 100% !important
    padding-right 0px
    margin 0
  >>>.el-progress__text
    color #fff
  >>>.el-progress-bar__outer
    background-color rgba(0, 0, 0, 0) !important
    border 1px #1B9BFF solid
  >>>.el-progress-bar__inner
    left 1% !important
    top 20% !important
    height 60% !important
    background-image linear-gradient(to right, #072A5E, #00B2E9)
  >>>.el-progress__text
    display none
@media (max-width 1280px)
  .tableBody
    font-size 0.08rem
</style>
